function addCustomStylingToDatePicker() {
    // for stylizing inline date picker
    let addWrapperToSelect = '<div class="AddWrapperToSelect"></div>';
    setTimeout(function() {
        $('.ui-datepicker-month').wrap(addWrapperToSelect);
        $('.ui-datepicker-year').wrap(addWrapperToSelect);

        $('.ui-datepicker-header .ui-datepicker-prev').addClass(
            'appended-icon icon-arrow-left'
        );
        $('.ui-datepicker-header .ui-datepicker-next').addClass(
            'appended-icon icon-arrow-right'
        );
    }, 0);
}

function addThousandsSeparator(n, separator) {
    n = parseInt(n, 10);
    if (typeof n === 'number') {
        n += '';
        var x = n.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + separator + '$2');
        }
        return x1 + x2;
    } else {
        return n;
    }
}

function addLeadingZeroToDate(val) {
    val = ('0' + val).slice(-2);

    return val;
}

// enable beforeShow callback to any inline datepicker
function extendDatePicker() {
    $.extend($.datepicker, {
        // Reference the orignal function so we can override it and call it later
        _inlineDatepicker2: $.datepicker._inlineDatepicker,

        // Override the _inlineDatepicker method
        _inlineDatepicker: function(target, inst) {
            // Call the original
            this._inlineDatepicker2(target, inst);

            var beforeShow = $.datepicker._get(inst, 'beforeShow');

            if (beforeShow) {
                beforeShow.apply(target, [target, inst]);
            }
        },
    });
}

function displayStandardProjectPrices(dateFormat) {
    let standardModalCallSelector =
        '.TypePrices--standard .TypePrices__duration';
    let standardSelector =
        '.TypePrices--standard .TypePrices__selected_duration';
    let standardDisabledDatePickerSelector =
        '.TypePrices--standard .CustomDatePicker--disabled';
    let standardStartDateModalCallSelector =
        '.TypePrices--standard .TypePrices__start_date';
    let standardStartDateSelector =
        '.TypePrices--standard .TypePrices__selected_start_date';
    let standardItemLockedSelector =
        '.TypePrices--standard .TypePrices__item--locked';
    let standardEndDateSelector =
        '.TypePrices--standard .TypePrices__selected_end_date';
    let labelStandardPriceSelector =
        '.TypePrices--standard .TypePrices__price';
    let standardDateCurrencyModalSelector =
        '.TypePrices--standard .TypePrices__currency';
    let standardCurrencySelector =
        '.TypePrices--standard .TypePrices__selected_currency';
    let standardDatePickerSelector =
        '.ModalPricesBlockStartDate .CustomDatePicker--start-date';
    let modalStandardSelector = '.ModalPricesBlockDurationStandard';
    let modalStandardStartDateSelector = '.ModalPricesBlockStartDate';
    let modalStandardCurrencySelector = '.ModalPricesBlockCurrency';

    let allStandardCurrencies = [];
    let allStandardCurrenciesData = [];

    $.each(productPrice['computedStandardPrices'], function(
        key,
        value
    ) {
        allStandardCurrencies.push(key);
        allStandardCurrenciesData.push(value);
    });

    // get default values
    if (
        typeof productPrice['localCurrency'] !== 'undefined' &&
        allStandardCurrencies.includes(productPrice['localCurrency'])
    ) {
        var workingCurrencyStandard = productPrice['localCurrency'];
    } else {
        var workingCurrencyStandard = allStandardCurrencies[0];
    }

    let defaultCurrency =
        productPrice['computedStandardPrices'][workingCurrencyStandard];
    let workingPriceFormatStandard =
        productPrice['computedStandardPrices'][workingCurrencyStandard][
            'price_format_string'
        ];
    let workingDurationStandard =
        productPrice['computedStandardPrices'][workingCurrencyStandard][
            'currency_prices'
        ][0]['duration_weeks'];
    let workingDurationDaysStandard =
        productPrice['computedStandardPrices'][workingCurrencyStandard][
            'currency_prices'
        ][0]['duration_days'];
    let workingCurrencySymbolStandard =
        productPrice['computedStandardPrices'][workingCurrencyStandard][
            'currency_display'
        ];
    let workingCurrencyCodeStandard =
        productPrice['computedStandardPrices'][workingCurrencyStandard][
            'currency_text'
        ];
    let thousandSeparatorStandard =
        productPrice['computedStandardPrices'][workingCurrencyStandard][
            'currency_thousand_separator'
        ];

    // Add fallback incase 'currency_thousand_separator' isn't defined
    if (typeof thousandSeparatorStandard === 'undefined')
        thousandSeparatorStandard = ',';

    let formatPrice = function(price) {
        price = addThousandsSeparator(price, thousandSeparatorStandard);

        return workingPriceFormatStandard
            .replace('{price}', price)
            .replace('{currency_symbol}', workingCurrencySymbolStandard)
            .replace('{currency_code}', workingCurrencyCodeStandard);
    };

    let defaultWeeksStandard =
        defaultCurrency['currency_prices'][0]['duration_text'];

    // Get the price of the minimum duration
    var defaultPrice = parseInt(
        defaultCurrency['currency_prices'][0]['price'],
        10
    );

    // Compute the total price for choices made and display
    var updatePrice = function () {
        var numOfAdults = 1;

        //Get the price for the current number of weeks chosen for one adult
        var weeksPrice = jQuery(labelStandardPriceSelector).attr(
            'data-current-weeks-price'
        );
        weeksPrice = parseInt(weeksPrice, 10);

        // Compute the total price for a adult
        var price = weeksPrice * numOfAdults;

        // Get the price ready for display (ie. add separator)
        computedPriceStandard = formatPrice(price);

        // Display computed prices including currency symbol
        jQuery(labelStandardPriceSelector).text(
            computedPriceStandard
        );
    };

    let translatedHeadingForModal = $(
        modalStandardSelector + ' .modal-header h6'
    ).text();

    // Default values now set in blade template
    // $(standardSelector).text(defaultWeeksStandard);

    $(standardSelector).val(workingDurationStandard);
    $(standardSelector).attr('data-days', workingDurationDaysStandard);
    $(standardCurrencySelector).text(workingCurrencyStandard).attr("value", workingCurrencyStandard);

    // default text & value for start date drop-down
    let defaultStartDateTextStandard = $(
        standardStartDateSelector
    ).val();

    jQuery(labelStandardPriceSelector).attr(
        'data-current-weeks-price',
        defaultPrice
    );

    // No longer setting default duration.
    // This is to allow an error popup when it has not been chosen
    // jQuery('.js-app-form-duration').val(workingDurationDaysStandard);

    if (allStandardCurrencies.length > 1) {
        $(standardDateCurrencyModalSelector).mousedown(function(event) {
            event.preventDefault();
        });

        $(standardDateCurrencyModalSelector).click(function() {
            $(modalStandardCurrencySelector).modal('show');
            // clear any previous existing list
            $(
                modalStandardCurrencySelector + ' .modal__item ul'
            ).remove();
            // create a list of currencies
            $(modalStandardCurrencySelector + ' .modal__item').append(
                '<ul class="ModalPricesBlockCurrency__select"></ul>'
            );
            $.each(allStandardCurrencies, function(key, value) {
                $('.ModalPricesBlockCurrency__select').append(
                    '<li><a href="#' +
                        value.toLowerCase() +
                        '" title="' +
                        allStandardCurrenciesData[key][
                            'currency_text'
                        ] +
                        '" class="Link Link--prices-block"' +
                        '><strong>' +
                        value +
                        '</strong> ' +
                        '</a></li>'
                );
            });

            $(
                modalStandardCurrencySelector + ' .Link--prices-block'
            ).each(function() {
                $(this).removeClass('LinkSelected');
                let aValue = $(this)
                    .children('strong')
                    .text();

                // highlight default/previous selection
                if (aValue == workingCurrencyStandard) {
                    $(this).addClass('LinkSelected');
                }

                $(this).click(function(event) {
                    event.preventDefault();

                    // get and reassign user selection to duration drop down
                    workingCurrencyStandard = $(this)
                        .children('strong')
                        .text();
                    $(standardCurrencySelector).text(
                        workingCurrencyStandard
                    ).attr("value", workingCurrencyStandard);

                    // get current duration
                    workingDurationStandard = $(standardSelector).val();

                    // get price in selected currency
                    workingCurrencySymbolStandard =
                        productPrice['computedStandardPrices'][
                            workingCurrencyStandard
                        ]['currency_display'];
                    workingPriceFormatStandard =
                        productPrice['computedStandardPrices'][
                            workingCurrencyStandard
                        ]['price_format_string'];
                    workingCurrencyCodeStandard =
                        productPrice['computedStandardPrices'][
                            workingCurrencyStandard
                        ]['currency_text'];
                    thousandSeparatorStandard =
                        productPrice['computedStandardPrices'][
                            workingCurrencyStandard
                        ]['currency_thousand_separator'];

                    let computedPriceAttr = '';
                    $.each(
                        productPrice['computedStandardPrices'][
                            workingCurrencyStandard
                        ]['currency_prices'],
                        function(key, value) {
                            if (
                                value['duration_weeks'] ==
                                workingDurationStandard
                            ) {
                                computedPriceAttr = parseInt(
                                    value['price'],
                                    10
                                );
                            }
                        }
                    );

                    jQuery(labelStandardPriceSelector).attr(
                        'data-current-weeks-price',
                        computedPriceAttr
                    );

                    // assign new price, close modal
                    updatePrice();
                    $(modalStandardCurrencySelector).modal('hide');
                });
            });
        });
    } else {
        $(
            '.TypePrices--standard .TypePrices__item--select-currency'
        ).remove();
    }

    /* duration select */
    $(standardModalCallSelector).mousedown(function(event) {
        event.preventDefault();
    });

    $(standardModalCallSelector).click(function() {
        $(modalStandardSelector).modal('show');

        // get selected duration to highlight selected duration within drop-down options
        let selectedDurationTextStandard = $(standardSelector).text();

        // clear any previous existing list
        $(modalStandardSelector + ' .modal__item ul').remove();

        // create a list of currencies
        $(modalStandardSelector + ' .modal__item').append(
            '<ul class="ModalPricesBlockStandard__select"></ul>'
        );

        $.each(
            productPrice['computedStandardPrices'][
                workingCurrencyStandard
            ]['currency_prices'],
            function(key, value) {
                $('.ModalPricesBlockStandard__select').append(
                    '<li><a href="#' +
                    value['duration_weeks'] +
                    '" title="' +
                    translatedHeadingForModal +
                    ': ' +
                    value['duration_text'] +
                    '" data-days="' +
                    value['duration_days'] +
                    '" data-weeks="' +
                    value['duration_weeks'] +
                    '" data-price="' +
                    value['price'] +
                    '" class="Link Link--prices-block">' +
                    value['duration_text'] +
                    ' - ' +
                    formatPrice(value['price']) +
                    '</a></li>'
                );
            }
        );

        $(modalStandardSelector + ' .Link--prices-block').each(
            function() {
                $(this).removeClass('LinkSelected');
                let aValue = $(this).text();

                // hightlight default/previous selection
                if (aValue == selectedDurationTextStandard) {
                    $(this).addClass('LinkSelected');
                }

                $(this).click(function(event) {
                    event.preventDefault();
                    // get user selection from duration drop down
                    selectedDurationTextStandard = $(this).text();
                    let selectedDurationWeeksStandard = $(this).attr(
                        'data-weeks'
                    );
                    let selectedDurationDaysStandard = $(this).attr(
                        'data-days'
                    );
                    $(standardSelector).text(
                        selectedDurationTextStandard
                    );
                    $(standardSelector).val(
                        selectedDurationWeeksStandard
                    );
                    $(standardSelector).attr(
                        'data-days',
                        selectedDurationDaysStandard
                    );

                    // check date picker for any selected start date
                    let checkSelectedDate = $(
                        standardStartDateSelector
                    ).val();

                    if (
                        checkSelectedDate !=
                        defaultStartDateTextStandard
                    ) {
                        // call a disabled date picker to can compute the new end date
                        $(
                            standardDisabledDatePickerSelector
                        ).datepicker({
                            disabled: true,
                        });
                        // calculate end date
                        let numberOfDays =
                            parseInt(selectedDurationDaysStandard) - 1;

                        let d = new Date(
                            // reformat date so ios safari can parse it
                            checkSelectedDate
                                .replace(/\ (\d)(?!\d+)/g, function(
                                    _,
                                    $1
                                ) {
                                    return ' 0' + $1;
                                })
                                .replace(/\ /g, '-')
                        );

                        let computedEndDate = new Date(
                            d.getFullYear(),
                            d.getMonth(),
                            d.getDate() + numberOfDays
                        );

                        // custom format start and end date
                        computedEndDate = $.datepicker.formatDate(
                            dateFormat,
                            computedEndDate
                        );

                        // display computed end date
                        $(standardItemLockedSelector).removeClass(
                            'Hide'
                        );
                        $(standardItemLockedSelector).addClass('Show');
                        $(standardEndDateSelector).text(
                            computedEndDate
                        );

                        jQuery('.js-app-form-start-date').val(d.getDate() + '-' + (d.getMonth() + 1) + '-' + d.getFullYear());
                    }

                    jQuery(labelStandardPriceSelector).attr(
                        'data-current-weeks-price',
                        jQuery(this).attr('data-price')
                    );

                    updatePrice();
                    $(modalStandardSelector).modal('hide');

                    jQuery('.js-app-form-duration-days').val(
                        selectedDurationDaysStandard
                    );
                });
            }
        );
    });

    /* start date select */
    $(standardStartDateModalCallSelector).mousedown(function(event) {
        event.preventDefault();
    });

    $(standardStartDateModalCallSelector).click(function() {
        // default settings for date picker
        // allow month & year change
        // disable all past dates (today = 0)
        // use short day's names (3 letters) instead of minimal day's names (2 letters)
        // define actions on select
        let datePickerArgs = {
            changeMonth: true,
            changeYear: true,
            minDate: 0,
            dayNamesMin: $.datepicker._defaults.dayNamesShort,
            onSelect: function() {
                workingDurationStandard = $(standardSelector).val();
                let selectedDurationDaysStandard = $(
                    standardSelector
                ).attr('data-days');
                let selectedStartDateValueStandard = $(this).datepicker(
                    'getDate'
                );
                let selectedStartDateValueStandardMachine = '';

                // calculate end date
                let numberOfDays =
                    parseInt(selectedDurationDaysStandard) - 1;
                let d = new Date(selectedStartDateValueStandard);
                let computedEndDate = new Date(
                    d.getFullYear(),
                    d.getMonth(),
                    d.getDate() + numberOfDays
                );

                // custom format start and end date
                selectedStartDateValueStandard = $.datepicker.formatDate(
                    dateFormat,
                    selectedStartDateValueStandard
                );
                selectedStartDateValueStandardMachine =
                    d.getFullYear() +
                    ' ' +
                    (d.getMonth() + 1) +
                    ' ' +
                    d.getDate();
                computedEndDate = $.datepicker.formatDate(
                    dateFormat,
                    computedEndDate
                );

                // display dates
                $(standardStartDateSelector).text(
                    selectedStartDateValueStandard
                );
                $(standardStartDateSelector).val(
                    selectedStartDateValueStandardMachine
                );
                $(standardItemLockedSelector).removeClass('Hide');
                $(standardItemLockedSelector).addClass('Show');
                $(standardEndDateSelector).text(computedEndDate);

                // close modal
                $(modalStandardStartDateSelector).modal('hide');


                jQuery('.js-app-form-start-date').val(d.getDate() + '-' + (d.getMonth() + 1) + '-' + d.getFullYear());
            },
            beforeShow: addCustomStylingToDatePicker,
            onChangeMonthYear: addCustomStylingToDatePicker,
        };

        // open modal
        $(modalStandardStartDateSelector).modal('show');

        // call date picker
        $(standardDatePickerSelector).datepicker(datePickerArgs);

        // I'll chose later option
        // clear start and any computed end date
        // re-assign default text & value to select
        // hide computed end date entirely
        // close date picker & modal
        $(
            modalStandardStartDateSelector + ' .Link--choose-later'
        ).click(function(event) {
            event.preventDefault();

            $(standardDatePickerSelector).datepicker('setDate', null);
            let computedEndDate = '';
            $(standardEndDateSelector).text(computedEndDate);
            $(standardItemLockedSelector).removeClass('Show');
            $(standardItemLockedSelector).addClass('Hide');
            $(standardStartDateSelector).text(
                defaultStartDateTextStandard
            );

            // close modal
            $(modalStandardStartDateSelector).modal('hide');
        });
    });

    $(modalStandardStartDateSelector).on('hidden.bs.modal', function() {
        // unwrap month/year select
        if (
            $('select')
                .parent()
                .hasClass('AddWrapperToSelect')
        ) {
            $('.ui-datepicker-month').unwrap();
            $('.ui-datepicker-year').unwrap();
        }

        // close date picker
        $(standardDatePickerSelector).datepicker('hide');
    });

    // hide livechat when date and duration menus opened
    jQuery(
        modalStandardSelector + ', ' + modalStandardStartDateSelector
    ).on('show.bs.modal', function() {
        if (window.innerWidth < 900) {
            jQuery('#hubspot-messages-iframe-container').addClass('js-livechat-hidden');
            jQuery(this).one('hide.bs.modal', function() {
                jQuery('#hubspot-messages-iframe-container').removeClass('js-livechat-hidden');
            });
        }
    });
}

function displayFixedDateProjectPrices(dateFormat) {
    let fixedDatesDisabledDatePickerSelector =
        '.TypePrices--fixed-dates .CustomDatePicker--disabled';
    let fixedDatesModalCallSelector =
        '.TypePrices--fixed-dates .TypePrices__selected_fixed_date';
    let fixedDatesWeeksSelector =
        '.TypePrices--fixed-dates .TypePrices__selected_duration';
    let labelFixedDatesPriceSelector =
        '.TypePrices--fixed-dates .TypePrices__price';
    let fixedDatesCurrencySelector =
        '.TypePrices--fixed-dates .TypePrices__selected_currency';
    let fixedDatesCurrencyModalSelector =
        '.TypePrices--fixed-dates .TypePrices__currency';
    let modalFixedDatesSelector = '.ModalPricesBlockFixedDate';
    let modalFixedDatesCurrencySelector = '.ModalPricesBlockCurrency';
    let fixedDatesDisabledDatePickerSelectorModal =
        modalFixedDatesSelector + ' .CustomDatePicker--disabled-modal';

    let fixedDatesStringDelimiter = ' - ';

    let allFixedDatesCurrencies = [];
    let allFixedDatesCurrenciesText = [];

    $.each(productPrice['computedFixedDatesPrices'], function(
        key,
        value
    ) {
        allFixedDatesCurrencies.push(key);
        allFixedDatesCurrenciesText.push(value['currency_text']);
    });

    // get default values
    let workingCurrencyFixedDates = '';
    if (
        typeof productPrice['localCurrency'] !== 'undefined' &&
        allFixedDatesCurrencies.includes(productPrice['localCurrency'])
    ) {
        workingCurrencyFixedDates = productPrice['localCurrency'];
    } else {
        workingCurrencyFixedDates = allFixedDatesCurrencies[0];
    }

    let defaultCurrencyFixedDates =
        productPrice['computedFixedDatesPrices'][
            workingCurrencyFixedDates
        ];
    let workingPriceFormatFixedDates =
        productPrice['computedFixedDatesPrices'][
            workingCurrencyFixedDates
        ]['price_format_string'];
    let workingFixedDate =
        defaultCurrencyFixedDates['currency_prices'][0]['start_date'];
    let workingDurationWeeksFixedDates =
        defaultCurrencyFixedDates['currency_prices'][0][
            'duration_weeks'
        ];
    let workingDurationDaysFixedDates =
        defaultCurrencyFixedDates['currency_prices'][0][
            'duration_days'
        ];
    let workingDurationTextFixedDates =
        defaultCurrencyFixedDates['currency_prices'][0][
            'duration_text'
        ];
    let workingCurrencySymbolFixedDates =
        defaultCurrencyFixedDates['currency_display'];
    let workingCurrencyCodeFixedDates =
        defaultCurrencyFixedDates['currency_text'];
    let thousandSeparatorFixedDates =
        defaultCurrencyFixedDates['currency_thousand_separator'];
    let translatedHeadingForModal = $(
        modalFixedDatesSelector + ' .modal-header h6'
    ).text();

    let formatPrice = function(price) {
        price = addThousandsSeparator(
            price,
            thousandSeparatorFixedDates
        );

        return workingPriceFormatFixedDates
            .replace('{price}', price)
            .replace(
                '{currency_symbol}',
                workingCurrencySymbolFixedDates
            )
            .replace('{currency_code}', workingCurrencyCodeFixedDates);
    };

    let formatDateString = function(
        startDate,
        endDate,
        numOfWeeks,
        shouldUpdateInput
    ) {
        var dateString = productPrice['dates_duration_format_label']
            .replace('{start_date}', startDate.replace(/ /g, '&nbsp;'))
            .replace('{end_date}', endDate.replace(/ /g, '&nbsp;'))
            .replace(
                '{duration_weeks}',
                numOfWeeks.replace(/ /g, '&nbsp;')
            );

        if (shouldUpdateInput) {
            $(fixedDatesModalCallSelector).html(dateString);
        }

        return dateString;
    };

    let updateDateValueForAppForm = function(date, numDays) {
        let input = jQuery('.js-app-form-start-date');
        let dateFormat = input.attr('data-format');
        let dateString = dateFormat
            .replace('{day}', addLeadingZeroToDate(date.getUTCDate()))
            .replace(
                '{month}',
                addLeadingZeroToDate(date.getUTCMonth() + 1)
            )
            .replace('{year}', date.getUTCFullYear());
        input.val(dateString);

        input = jQuery('.js-app-form-duration-days');
        input.val(numDays);
    };

    let computedPriceFixedDates = formatPrice(
        defaultCurrencyFixedDates['currency_prices'][0]['price']
    );

    // assign default value (now set in blade template)
    // $(labelFixedDatesPriceSelector).text(computedPriceFixedDates);

    $(fixedDatesCurrencySelector).text(workingCurrencyFixedDates).attr("value", workingCurrencyFixedDates);
    // assign the default incoming value for further using
    $(fixedDatesWeeksSelector).val(workingDurationWeeksFixedDates);

    if (allFixedDatesCurrencies.length > 1) {
        $(fixedDatesCurrencyModalSelector).mousedown(function(event) {
            event.preventDefault();
        });

        $(fixedDatesCurrencyModalSelector).click(function() {
            $(modalFixedDatesCurrencySelector).modal('show');

            // clear any previous existing list
            $(
                modalFixedDatesCurrencySelector + ' .modal__item ul'
            ).remove();

            // create a list of currencies
            $(modalFixedDatesCurrencySelector + ' .modal__item').append(
                '<ul class="ModalPricesBlockCurrency__select"></ul>'
            );
            $.each(allFixedDatesCurrencies, function(key, value) {
                $('.ModalPricesBlockCurrency__select').append(
                    '<li><a href="#' +
                        value.toLowerCase() +
                        '" title="' +
                        allFixedDatesCurrenciesText[key] +
                        '" class="Link Link--prices-block"' +
                        '><strong>' +
                        value +
                        '</strong> ' +
                        '</a></li>'
                );
            });

            $(
                modalFixedDatesCurrencySelector + ' .Link--prices-block'
            ).each(function() {
                $(this).removeClass('LinkSelected');
                let aValue = $(this)
                    .children('strong')
                    .text();

                // hightlight default/previous selection
                if (aValue == workingCurrencyFixedDates) {
                    $(this).addClass('LinkSelected');
                }

                $(this).click(function(event) {
                    event.preventDefault();

                    // get and reassign user selection to duration drop down
                    workingCurrencyFixedDates = $(this)
                        .children('strong')
                        .text();
                    $(fixedDatesCurrencySelector).text(
                        workingCurrencyFixedDates
                    ).attr("value", workingCurrencyFixedDates);

                    // get current fixed date and duration
                    workingFixedDate = $(
                        fixedDatesModalCallSelector
                    ).attr('data-start-date');
                    workingFixedDate = workingFixedDate
                        .split(fixedDatesStringDelimiter)
                        .shift();
                    // call a disabled date picker to can format received dates from database
                    $(
                        fixedDatesDisabledDatePickerSelectorModal
                    ).datepicker({
                        disabled: true,
                    });
                    workingFixedDate = new Date(workingFixedDate);
                    workingFixedDate =
                        workingFixedDate.getFullYear() +
                        '-' +
                        addLeadingZeroToDate(
                            workingFixedDate.getMonth() + 1
                        ) +
                        '-' +
                        addLeadingZeroToDate(
                            workingFixedDate.getDate()
                        );

                    workingDurationWeeksFixedDates = $(
                        fixedDatesWeeksSelector
                    ).val();

                    // get price in selected currency
                    workingCurrencySymbolFixedDates =
                        productPrice['computedFixedDatesPrices'][
                            workingCurrencyFixedDates
                        ]['currency_display'];
                    workingCurrencyCodeFixedDates =
                        productPrice['computedFixedDatesPrices'][
                            workingCurrencyFixedDates
                        ]['currency_text'];
                    workingPriceFormatFixedDates =
                        productPrice['computedFixedDatesPrices'][
                            workingCurrencyFixedDates
                        ]['price_format_string'];
                    thousandSeparatorFixedDates =
                        productPrice['computedFixedDatesPrices'][
                            workingCurrencyFixedDates
                        ]['currency_thousand_separator'];

                    $.each(
                        productPrice['computedFixedDatesPrices'][
                            workingCurrencyFixedDates
                        ]['currency_prices'],
                        function(key, value) {
                            if (
                                value['start_date'] ==
                                    workingFixedDate &&
                                value['duration_weeks'] ==
                                    workingDurationWeeksFixedDates
                            ) {
                                computedPriceFixedDates = formatPrice(
                                    parseInt(value['price'])
                                );
                            }
                        }
                    );

                    // assign new price, close modal
                    $(labelFixedDatesPriceSelector).text(
                        computedPriceFixedDates
                    );
                    $(modalFixedDatesCurrencySelector).modal('hide');

                    updateDateValueForAppForm(
                        workingFixedDate,
                        numberOfDays + 1
                    );
                });
            });
        });
    } else {
        $(
            '.TypePrices--fixed-dates .TypePrices__item--select-currency'
        ).remove();
    }

    // call a disabled date picker to can format received fixed dates and compute end dates
    // use alternate field to can display date in a custom format
    $(fixedDatesDisabledDatePickerSelector).datepicker({
        altField: fixedDatesModalCallSelector,
        altFormat: dateFormat,
        disabled: true,
    });

    // Set the default date/duration
    var workingFixedDateObj = new Date(workingFixedDate);
    var workingFixedUTCDateObj = new Date(
        workingFixedDateObj.getUTCFullYear(),
        workingFixedDateObj.getUTCMonth(),
        workingFixedDateObj.getUTCDate()
    );
    $(fixedDatesDisabledDatePickerSelector).datepicker(
        'setDate',
        workingFixedUTCDateObj
    );

    // Get the computed default end date based of the default fixed date and default number of weeks
    let numberOfDays = parseInt(workingDurationDaysFixedDates) - 1;
    let d = new Date(workingFixedDate);
    let computedEndDate = new Date(
        d.getUTCFullYear(),
        d.getUTCMonth(),
        d.getUTCDate() + numberOfDays
    );
    computedEndDate = $.datepicker.formatDate(
        dateFormat,
        computedEndDate
    );

    // Display default fixed date along with the default number of weeks
    let datesWithWeeks = formatDateString(
        $(fixedDatesModalCallSelector).val(),
        computedEndDate,
        workingDurationTextFixedDates,
        false // Default now set in the blade template
    );

    $(fixedDatesModalCallSelector).attr(
        'data-start-date',
        workingFixedDate
    );

    // updateDateValueForAppForm(d, numberOfDays + 1);
    if (
        productPrice['computedFixedDatesPrices'][
            workingCurrencyFixedDates
        ]['currency_prices'].length > 0
    ) {
        $(fixedDatesModalCallSelector).click(function() {
            $(modalFixedDatesSelector).modal('show');

            // call a disabled date picker to can format received dates from database
            $(fixedDatesDisabledDatePickerSelectorModal).datepicker({
                disabled: true,
            });

            // clear any previous existing list
            $(modalFixedDatesSelector + ' .modal__item ul').remove();

            // create a list of available dates
            $(modalFixedDatesSelector + ' .modal__item').append(
                '<ul class="ModalPricesBlockFixedDate__select"></ul>'
            );
            $.each(
                productPrice['computedFixedDatesPrices'][
                    workingCurrencyFixedDates
                ]['currency_prices'],
                function(key, value) {
                    var startDate = new Date(value['start_date']);

                    var displayStartDate = new Date(
                        startDate.getUTCFullYear(),
                        startDate.getUTCMonth(),
                        startDate.getUTCDate()
                    );
                    displayStartDate = $.datepicker.formatDate(
                        dateFormat,
                        displayStartDate
                    );

                    numberOfDays = parseInt(value['duration_days']) - 1;
                    var endDate = new Date(
                        startDate.getUTCFullYear(),
                        startDate.getUTCMonth(),
                        startDate.getUTCDate() + numberOfDays
                    );

                    var formattedEndDate = $.datepicker.formatDate(
                        dateFormat,
                        endDate
                    );

                    var formattedDateString = formatDateString(
                        displayStartDate,
                        formattedEndDate,
                        value['duration_text']
                    );

                    $('.ModalPricesBlockFixedDate__select').append(
                        '<li><a href="#' +
                            value['duration_weeks'] +
                            '" data-weeks="' +
                            value['duration_weeks'] +
                            '" data-days="' +
                            value['duration_days'] +
                            '" data-duration-text="' +
                            value['duration_text'] +
                            '" data-start-date="' +
                            value['start_date'] +
                            '" title="' +
                            translatedHeadingForModal +
                            '" class="Link Link--prices-block">' +
                            formattedDateString +
                            '</a></li>'
                    );
                }
            );

            $(
                modalFixedDatesSelector + ' .Link--prices-block'
            ).removeClass('LinkSelected');

            $(modalFixedDatesSelector + ' .Link--prices-block').each(
                function() {
                    let aValue = $(this).html();

                    // highlight default/previous selection
                    if (aValue === datesWithWeeks) {
                        $(this).addClass('LinkSelected');
                    }

                    $(this).click(function(event) {
                        event.preventDefault();

                        // get user selected start date from duration drop down
                        workingFixedDate = $(this).attr(
                            'data-start-date'
                        );

                        workingDurationWeeksFixedDates = $(this).attr(
                            'data-weeks'
                        );
                        workingDurationDaysFixedDates = $(this).attr(
                            'data-days'
                        );
                        workingDurationTextFixedDates = $(this).attr(
                            'data-duration-text'
                        );

                        // compute end date based on selection
                        numberOfDays =
                            parseInt(workingDurationDaysFixedDates) - 1;
                        d = new Date(workingFixedDate);
                        computedEndDate = new Date(
                            d.getUTCFullYear(),
                            d.getUTCMonth(),
                            d.getUTCDate() + numberOfDays
                        );
                        computedEndDate = $.datepicker.formatDate(
                            dateFormat,
                            computedEndDate
                        );

                        workingCurrencySymbolFixedDates =
                            productPrice['computedFixedDatesPrices'][
                                workingCurrencyFixedDates
                            ]['currency_display'];
                        thousandSeparatorFixedDates =
                            productPrice['computedFixedDatesPrices'][
                                workingCurrencyFixedDates
                            ]['currency_thousand_separator'];

                        // Get new price for selected date
                        $.each(
                            productPrice['computedFixedDatesPrices'][
                                workingCurrencyFixedDates
                            ]['currency_prices'],
                            function(key, value) {
                                if (
                                    value['start_date'] ==
                                        workingFixedDate &&
                                    value['duration_weeks'] ==
                                        workingDurationWeeksFixedDates
                                ) {
                                    computedPriceFixedDates = formatPrice(
                                        value['price']
                                    );
                                }
                            }
                        );

                        // Create new start date for selected date for UTC timezone
                        let workingFixedDateFormatted = new Date(
                            d.getUTCFullYear(),
                            d.getUTCMonth(),
                            d.getUTCDate()
                        );
                        workingFixedDateFormatted = $.datepicker.formatDate(
                            dateFormat,
                            workingFixedDateFormatted
                        );

                        // Display select date
                        datesWithWeeks = formatDateString(
                            workingFixedDateFormatted,
                            computedEndDate,
                            workingDurationTextFixedDates,
                            true
                        );

                        $(fixedDatesModalCallSelector).attr(
                            'data-start-date',
                            workingFixedDate
                        );

                        $(fixedDatesWeeksSelector).val(
                            workingDurationWeeksFixedDates
                        );

                        // Display selected date's price
                        $(labelFixedDatesPriceSelector).text(
                            computedPriceFixedDates
                        );

                        // Close modal
                        $(modalFixedDatesSelector).modal('hide');

                        updateDateValueForAppForm(d, numberOfDays + 1);
                    });
                }
            );
        });
    } else {
        $(fixedDatesModalCallSelector)
            .parent()
            .removeClass('TypePrices__item--select')
            .addClass('TypePrices__item--select-locked');
    }

    // hide livechat when date and duration menus opened
    jQuery(modalFixedDatesSelector).on('show.bs.modal', function() {
        if (window.innerWidth < 900) {
            jQuery('#hubspot-messages-iframe-container').addClass('js-livechat-hidden');
            jQuery(this).one('hide.bs.modal', function() {
                jQuery('#hubspot-messages-iframe-container').removeClass('js-livechat-hidden');
            });
        }
    });
}

jQuery(function ($) {
    extendDatePicker();

    if (typeof productPrice === 'undefined') {
        return;
    }

    let dateFormat = jQuery('#js-date-format').attr('data-format');

    if (
        typeof productPrice['computedStandardPrices'] !== 'undefined' &&
        productPrice['computedStandardPrices'] != ''
    ) {
        displayStandardProjectPrices(dateFormat);
    } else {
        if ($('.TypePrices--standard').length > 0) {
            $('.TypePrices--standard').remove();
        }
    }

    if (
        typeof productPrice['computedFixedDatesPrices'] !== 'undefined' &&
        productPrice['computedFixedDatesPrices'] != ''
    ) {
        displayFixedDateProjectPrices(dateFormat);
    } else {
        if ($('.TypePrices--fixed-dates').length > 0) {
            $('.TypePrices--fixed-dates').remove();
        }
    }

    jQuery('.Form__container--prices-block').validate({
        ignore: '', // default is ignore: ':hidden'
        errorPlacement: () => true, // disable default error message
        invalidHandler: () => jQuery('.TypePrices__overlay')
            .removeClass('TypePrices__overlay--hidden')
    });

    // Remove error message on click
    jQuery('.TypePrices__overlay').click(() =>
        jQuery('.TypePrices__overlay').addClass('TypePrices__overlay--hidden')
    );
});